<template>
	<el-table
		:data="sortedExcretion"
		:show-header="false"
		style="width:100%">

		<el-table-column width="130">
			<template slot-scope="scope">
				<strong>{{ formatDate(scope.row.time) }}</strong>
				&middot;
				{{ formatTime(scope.row.time) }}
			</template>
		</el-table-column>

		<el-table-column width="125">
			<template slot-scope="scope">
				<div class="form">
					<img :src="formImage(scope.row.form)">
					<strong>{{ formatForm(scope.row.form) }}</strong>
				</div>
			</template>
		</el-table-column>

		<el-table-column width="125">
			<template slot-scope="scope">
				<div class="color">
					<div class="preview" v-bind:style="{ background: colorCode(scope.row.color) }"></div>
					<label>
						{{ formatColor(scope.row.color) }}
					</label>
				</div>
			</template>
		</el-table-column>
		<el-table-column>
			<template slot-scope="scope">
				<div class="detail">
					<span class="blood" v-if="scope.row.blood">Blood</span>
					<span class="mucus" v-if="scope.row.mucus">Mucus</span>
					<span class="experience"
						v-for="experience in getExperience(scope.row.experience)"
						:key="experience">
						{{ experience }}
					</span>
				</div>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import ExcretionAnalysis from '.'

export default {
	name: 'patient-lifestyle-card-excretion-table',
	extends: ExcretionAnalysis

}
</script>

<style lang="scss" scoped>
.form {
	img {
		float: left;
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
	strong {
		margin-left: 5px;
	}
}
.color {
	.preview {
		float: left;
		width: 20px;
		height: 20px;
		border: solid 2px rgba(0, 0, 0, 0.2);
		margin-right: 5px;
	}
	label {
		text-transform: capitalize;
		color: #4f4f4f;
		font-weight: 500;
	}
}
.detail {
	span {
		text-transform: capitalize;
		padding: 3px 8px;
		border-radius: 10px;
		background: #e7e7e7;
		margin-right: 5px;
	}
	.blood {
		background: lighten(#da4e4e, 20%);
		color: darken(#da4e4e, 30%);
		font-weight: 700;
	}
	.mucus {
		background: lighten(#fa9e25, 20%);
		color: darken(#fa9e25, 20%);
		font-weight: 700;
	}
}
</style>
